/*
 * Copyright (C) 2026 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {useScope as createI18nScope} from '@canvas/i18n'
import {Alert} from '@instructure/ui-alerts'
import {Text} from '@instructure/ui-text'
import React from 'react'

const I18n = createI18nScope('new_login')

type AlertVariant = 'info' | 'success' | 'warning' | 'error'

const variantSrLabel = (variant: AlertVariant) => {
  switch (variant) {
    case 'success':
      return I18n.t('Success,')
    case 'warning':
      return I18n.t('Warning,')
    case 'error':
      return I18n.t('Error,')
    case 'info':
    default:
      return I18n.t('Information,')
  }
}

type Props = {
  message: string
  variant?: AlertVariant
}

const MessageAlert = ({message, variant = 'info'}: Props) => {
  return (
    <Alert
      data-testid="custom-message-alert"
      hasShadow={false}
      variant={variant}
      variantScreenReaderLabel={variantSrLabel(variant)}
    >
      <Text wrap="break-word">{message}</Text>
    </Alert>
  )
}

export default MessageAlert
